import Api from '@/api/Api';

export default {
  getConfig() {
    return Api().get('/config');
  },
};
